// TODO: certain version of Node may return ',' regardless of provided locale.
// that is due to Intl being buggy or not working correctly in that environment
// Solution: align `toLocaleString` behaviour in Node to browser's one, then
// expand test coverage for different locales
exports.getNumberSeparator = (locale) => {
  const dummy = 12345.6789.toLocaleString(locale).match(/12(.*)345/);
  return dummy && dummy[1] ? dummy[1] : ',';
};

exports.sanitizeHTML = (htmlString, allowedElements = []) => {
  // ESLint is complaining about not needed escaped character,
  // but they need to be escaped
  /* eslint-disable-next-line */
  const expression = `<(?!((?:\/\s*)?(?:${allowedElements.join('|')})))([^>])+>`;
  const regExp = new RegExp(expression, 'g');

  return htmlString.replace(regExp, '');
};

exports.isDateInLastDays = (date, days) => {
  const displayUntilTime = date + (days * 24 * 60 * 60 * 1000);
  const timeNow = Date.now();
  return date <= timeNow && timeNow < displayUntilTime;
};

exports.getHeimdallCookieDomain = (hostname) => (`.${hostname.split(':')[0]}`);

exports.getCookieOptions = (domain, expireDate) => {
  let expires = expireDate;

  if (!expires) {
    expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
  }

  return {
    domain: domain || '.ecosia.org',
    expires,
    path: '/',
  };
};

exports.clamp = (value, low, high) => Math.max(low, Math.min(high, value));
/* eslint-enable import/prefer-default-export */

// prepares a search query for adding to a URL (for redirects etc.)
exports.prepareQuery = (query) => encodeURIComponent(
  decodeURIComponent(query).trim());

exports.truncateText = (text, length) => {
  if (text.length > length) {
    return `${text.substring(0, length)}…`;
  }
  return text;
};

// escapes string special characters for regular expression
// see https://stackoverflow.com/questions/3115150/how-to-escape-regular-expression-special-characters-using-javascript
exports.escapeSpecialCharsForRegex = (string) => string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

exports.createMarkHtml = (string, classes = '', testId = '') => {
  const regex = new RegExp(`(${exports.escapeSpecialCharsForRegex(string)})`, 'ig');
  // template string intentionally left without whitespace
  // to avoid spaces rendered inside the <mark>
  return (text) => text.replace(regex, ($1, match) => `<mark class="${classes}" data-test-id="${testId}">${match}</mark>`);
};

/**
 * Creates a "batcher" function which will call the provided `callee` function
 * at most once every `waitMs`. The rest of the batcher calls are queued up
 * and passed to the callee after the wait.
 *
 * The callee will be passed an array of `args` arrays from
 * each call to the batcher.
 *
 * @param {function} callee the function to call with the collected batches
 * @param {number} waitMs how long to wait till executing a new batch
 */
exports.batchCall = (callee, waitMs = 1000) => {
  let queue = [];
  let waiting = false;

  const call = () => {
    if (queue.length > 0) {
      callee(queue.slice());
    }
  };

  return (...args) => {
    queue.push([...args]);

    if (!waiting) {
      call();
      waiting = true;
      queue = [];

      setTimeout(() => {
        call();
        waiting = false;
      }, waitMs);
    }
  };
};
